'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationLogo = function (_React$Component) {
  _inherits(NotificationLogo, _React$Component);

  function NotificationLogo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationLogo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationLogo.__proto__ || Object.getPrototypeOf(NotificationLogo)).call.apply(_ref, [this].concat(args))), _this), _this.renderLogo = function (logo) {
      if (logo) {
        return _react2.default.createElement('img', { className: 'notification-ribbon__partners', src: logo.src, alt: logo.alt });
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationLogo, [{
    key: 'render',
    value: function render() {
      var logo = this.props.content.logo;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        this.renderLogo(logo)
      );
    }
  }]);

  return NotificationLogo;
}(_react2.default.Component);

exports.default = NotificationLogo;


NotificationLogo.propTypes = {
  content: _propTypes2.default.shape({
    logo: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }).isRequired
  })
};

NotificationLogo.defaultProps = {
  content: {
    logo: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/shared/partnerlogo-ribbon/cc_gray_logo.png',
      alt: 'Single Logo'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/notification-ribbon-partners/jsx/NotificationLogo.js
// module id = 669
// module chunks = 4